import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { signOut } from "../../../../store/sessionSlice";
import { roleToLabel } from "../../../../helpers/RoleHelper";

import ProfileEdit from "./ProfileEdit";
import { EditOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Popover, Avatar, Button } from 'antd';
import './style.scss';

const ProfileMenu: React.FC = () =>  {
  const dispatch = useAppDispatch();
  const { admin } = useAppSelector(state => state.session);
  const [menuOpen, setMenuOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);

  const onLogOutClick = () => {
    dispatch(signOut());
  };

  const onEditClick = () => {
    setMenuOpen(false);
    setEditOpen(true);
  };

  function Menu() {
    const { username, role } = admin;

    return (
      <div className="profile-menu">
        <div className="details-box">
          <div className="img-user">
            <Avatar src={admin.avatar_url} shape="square" size={80} icon={<UserOutlined />} />
          </div>

          <h6>{username}</h6>
          <span>{roleToLabel(role)} Role</span>
        </div>

        <Button className="dropdown-item" onClick={onEditClick} type='text'>
          <EditOutlined className="item-icon" /> Edit Profile
        </Button>

        <Button className="dropdown-item" onClick={onLogOutClick} type='text'>
          <LogoutOutlined className="item-icon" /> Sign Out
        </Button>
      </div>
    );
  }

  return (
    <>
      <Popover
        overlayClassName='profile-popover'
        placement="bottomRight"
        content={Menu}
        trigger={'click'}
        open={menuOpen}
        onOpenChange={setMenuOpen}
      >
        <Avatar src={admin.avatar_url} shape="square" size={32} icon={<UserOutlined />} />
      </Popover>

      <ProfileEdit open={editOpen} onClose={() => setEditOpen(false)} />
    </>
  );
}

export default ProfileMenu;
